export default "__VITE_ASSET__DaUDzU6p__"